import { rootDomain } from '@/util/helpers/essential-helpers';
import {
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  MODAL_INTERACTION,
} from '../actions/constants';
import ModalShareAsHtml from '../components/modals/ModalShareAsHtml';
import { MODAL_SHARE_AS_HTML } from '../util/enums/EnumModals';

const INITIAL_STATE = {
  dashboard: false,
  shareableSeries: null,
  shareablePassword: null,
};

const modalShareAsHtml = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED: {
      if (action.payload.modal === ModalShareAsHtml) {
        if (action.payload.dashboard) {
          return {
            ...INITIAL_STATE,
            url: `${rootDomain()}/share/dashboard/${
              action.payload.publicId
            }/load.html`,
            shareablePassword: action.payload.publicPin,
          };
        }
        const shareableSeries = action.payload.json._shareableSeries;
        return {
          ...INITIAL_STATE,
          url: `${rootDomain()}/share/view/${shareableSeries}/load.html`,
          shareablePassword: action.payload.json._shareablePassword,
        };
      }
      return state;
    }
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== MODAL_SHARE_AS_HTML) {
        return state;
      }
      return state;
    }
    default:
      return state;
  }
};

export default modalShareAsHtml;
